module.exports = __webpack_public_path__ + "img/mobile-categories.d218f20e.webp";